import { fieldCantBeEmptyMsg, t } from '../../i18n/index.js';
import { TextAreaComponent } from '../components/TextAreaComponent.js';
import type { OptionalInputComponentProps } from '../components/InputComponent.js';

interface MultipleEmailsProps extends OptionalInputComponentProps {
  maxEmails?: number;
  rows?: number;
}

export const MultipleEmails = ({
  className,
  disabled = false,
  label = t.RD75('Email address or addresses'),
  maxEmails = 500,
  name = 'emails',
  placeholder = t.HVK9('Add each email address to its own row'),
  required = true,
  rows = 4,
}: MultipleEmailsProps) => {
  const validate = (value: string) => {
    if (!value) {
      if (required) {
        return t.VPVR(fieldCantBeEmptyMsg);
      }
      return undefined;
    }
    const recipientEmails = value.split(/\r\n|\n|\r/).filter(Boolean);
    if (recipientEmails.length > maxEmails) {
      return t.HYGU('This field can contain up to {} email addresses.', maxEmails.toString());
    }
    return undefined;
  };

  return (
    <TextAreaComponent
      disabled={disabled}
      label={label}
      name={name}
      placeholder={placeholder}
      required={required}
      rows={rows}
      validate={validate}
      wrapperClassName={className}
    />
  );
};
